export enum LinkType {
  SecondaryButton = 'secondaryButton',
  Menu = 'menu',
  Text = 'text',
  Item = 'item',
}
